import React from "react";
import { InlineMath, BlockMath } from "react-katex";

const LatexText = ({ text }) => {
  if (!text) return null;

  // Supports:
  // $...$       → Inline math
  // $$...$$     → Block math
  // \(...\)     → Inline math
  // \[...\]     → Block math

  const parts = text.split(
    /(\$\$[\s\S]*?\$\$|\\\[[\s\S]*?\\\]|\\\([\s\S]*?\\\)|\$[^$]+\$)/g
  );

  return (
    <>
      {parts.map((part, index) => {
        // Display math: $$ ... $$
        if (part.startsWith("$$") && part.endsWith("$$")) {
          return (
            <BlockMath
              key={index}
              math={part.slice(2, -2).trim()}
            />
          );
        }

        // Display math: \[ ... \]
        if (part.startsWith("\\[") && part.endsWith("\\]")) {
          return (
            <BlockMath
              key={index}
              math={part.slice(2, -2).trim()}
            />
          );
        }

        // Inline math: \( ... \)
        if (part.startsWith("\\(") && part.endsWith("\\)")) {
          return (
            <InlineMath
              key={index}
              math={part.slice(2, -2).trim()}
            />
          );
        }

        // Inline math: $ ... $
        if (part.startsWith("$") && part.endsWith("$")) {
          return (
            <InlineMath
              key={index}
              math={part.slice(1, -1).trim()}
            />
          );
        }

        // Normal text
        return (
          <React.Fragment key={index}>
            {part}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default LatexText;